import { Alert, Button, Card, Col, message, Modal, Row } from 'antd';
import RadioGroup from 'antd/lib/radio/group';
import RadioButton from 'antd/lib/radio/radioButton';
import { EditableCell, EditableFormRow } from 'components/EditableTable';
import { withUserGroups } from 'components/userGroup';
import withOrgData from 'components/WithOrgData';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { compose } from 'redux';
import commonColumns from '../../../common/table/columns';
import { GlobalFilterWithWrapper } from '../../GlobalFilter';
import { Paginator } from '../../Paginator';
import PassengerTable from '../../tables/PassengerTable';
import {PassengerEditorModal} from "../../PassengerEditor/PassengerEditorModal";
import {withComplianceManagerDrawer} from "../../compliance/compliance-manager/drawer";

/**
 * Displays a real-time filterable table of the current active passengers for the selected transportation provider and customer.
 */
class LivePassengers_Internal extends Component {
    state = {
        editing: ""
    }
    getActiveTab = () => {
        return this.props.activeTab || 'outbound'
    }
    onTableChange = (_, filters) => {
        this.setState({ filters })
    }
    onTabChange = (activeTab) => this.props.onTabChange && this.props.onTabChange(activeTab)
    getColumns = () => {
        const activeTab = this.getActiveTab();
        const { customer, employer, transporter } = this.props.orgData;

        // Create custom set of columns for display in the table
        const columns = [
            {
                ...commonColumns.pax.columns.assignedFlight,
                defaultSortOrder: 'ascend'
            },
            {
                ...commonColumns.pax.columns.name,
                render: (text, record) => {
                    const name = commonColumns.pax.columns.name.render(text, record);
                    return <Button
                        className="mc-link-btn"
                        onClick={() => this.props.paxEditorModalState.open(record._id)}
                    >{name}</Button>
                }
            },
            !employer && commonColumns.pax.columns.employer,
            !customer && commonColumns.pax.columns.customer,
            !customer && !transporter ? commonColumns.pax.columns.transporter : undefined,
            ...commonColumns.pax.except(['name', 'assignedFlight', 'transitType', 'isn', 'compliance', 'restrictions', 'customer', 'employer', 'transporter']),
            {
                ...commonColumns.pax.columns.restrictions,
                width: 100
            },

            // ISN Column will only display when the Outbound tab is selected.
            // Inbound/Transfer passengers do not require an ISN status.
            activeTab === 'outbound' && {
                ...commonColumns.pax.columns.compliance
            }
        ].filter(col => col)
        return columns
    }

    render() {
        const { passengers=[], loading=false, error, refetch, skip, setSkip, userGroups } = this.props;
        const activeTab = this.getActiveTab();
        const onKeyDown = (e) => {
            const specialCharRegex = new RegExp("[a-zA-Z]");
            const pressedKey = e.key
            if ((pressedKey !== "Tab" && pressedKey !== "Backspace" && pressedKey !== "Delete") && specialCharRegex.test(pressedKey)) {
               e.preventDefault();
               return false;
            }
        }
        const columns = this.getColumns();
        return (
            <div>
                {/* Displays global filter banner. Controls filtering of data in PassengerTable */}
                <GlobalFilterWithWrapper />

                <h2>Passengers</h2>
                {error ? (
                    <Alert style={{ marginBottom: 12 }} showIcon type="error" message="Failed to load passengers" />
                ) : null}

                {/* OUTBOUND/TRANSFER/INBOUND tabs and other actions. */}
                <Row type="flex" gutter={12} style={{ marginBottom: 12 }}>
                    <Col>
                        <RadioGroup onChange={(e) => this.onTabChange(e.target.value)} value={activeTab} buttonStyle="solid">
                            <RadioButton value="outbound">
                                Outbound
                            </RadioButton>
                            <RadioButton value="inbound">
                                Inbound/Transfer
                            </RadioButton>
                        </RadioGroup>
                    </Col>
                    <Col>
                        <Button onClick={() => refetch()} icon="reload" loading={loading}>Refresh</Button>
                    </Col>
                    {userGroups.includes('flytsuite.live.passenger') ?
                    <Col>
                        <Button onClick={() => this.props.history.push('/app/passengers/checkin')}>Add Passenger</Button>
                    </Col> : null}
                    
                </Row>

                {/* Paginator to control the current page displayed in the PassengerTable below */}
                <Card size="small" style={{ marginBottom: 12 }}>
                    <Paginator
                    count={passengers.length}
                    skip={skip}
                    onChange={({ skip }) => setSkip(skip)}
                    size="small"
                    loading={loading}
                    />
                </Card>

                {/* Displays table of passengers that can be filtered and paginated. */}
                <PassengerTable
                    className="mc-table"
                    components={{
                        body: {
                            row: EditableFormRow,
                            cell: EditableCell
                        }
                    }} 
                    pagination={false}
                    rowKey={record => record._id}
                    dataSource={passengers} 
                    onChange={this.onTableChange}
                    columns={columns}
                    scroll={{ x: 'max-content' }}
                    size="small"
                />
                <PassengerEditorModal
                    api={this.props.paxEditorModalState}
                    edit={false}
                    onPassengerUpdated={() => this.props.refetch()}
                    onPassengerDeleted={() => this.props.refetch()}
                />
            </div>
        );
    }
}

LivePassengers_Internal.propTypes = {
    passengers: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    activeTab: PropTypes.any,
    onTabChange: PropTypes.func,
    refetch: PropTypes.func
}

function LivePassengers(props){

    const paxEditorModalState = PassengerEditorModal.useState();

    return <LivePassengers_Internal {...props} paxEditorModalState={paxEditorModalState} />
}
 
export default compose(
    withApollo,
    withOrgData,
    withUserGroups,
    withComplianceManagerDrawer
)(LivePassengers);